import { Theme } from '@mui/material/styles';
import { LotteryChipColour } from 'src/constants/lottery/chipColours';
import {
  resolveChipColours as resolveSharedChipColours,
  resolveThemeColour as resolveSharedThemeColour,
} from 'src/components/shared/RunProgress/chipStyles';

export interface LotteryChipStyle {
  backgroundColor: string;
  color: string;
  fontSize: number;
  height: number;
  '& .MuiChip-label': { px: number };
}

export function resolveThemeColour(theme: Theme, path: string): string {
  return resolveSharedThemeColour(theme, path);
}

export function resolveChipColours(
  theme: Theme,
  colour: LotteryChipColour
): LotteryChipStyle {
  return resolveSharedChipColours(theme, colour);
}
